<ion-content>
    @if (vendors().length) {
    @for (vendor of vendors(); track $index) {
    <ion-card class="card-common vendor-card primary-color cursor-pointer">

        <ion-item class="mb-25 rounded-2" color="list" lines="none" detail="false" [ngClass]="preferredGarages(vendor)">

            <!-- Icon -->
            <ion-avatar slot="start"
                class="bg-white avtarBox d-flex align-items-center justify-content-center rounded-1 p-25 mt-3 mb-auto">
                <ion-icon [src]="srcPath()" class="list-icon"></ion-icon>
            </ion-avatar>

            <ion-label class="detail_list_row d-block">

                <!-- Vendor Name -->
                <!-- <h2 class="primary-color font-family-bold vendorName text-wrap" (click)="navigateVendor.emit(vendor)"
                    (keydown.enter)="navigateVendor.emit(vendor)">
                    {{ vendor.vendoR_NAME || '-' }}
                </h2> -->

                <!-- Address -->
                <!-- <p class="d-flex align-items-start gap-1 mb-1">
                    <span class="cst-icon icon-location pt-1"></span>
                    <ion-text (click)="navigateVendor.emit(vendor)" (keydown.enter)="navigateVendor.emit(vendor)"
                        class="font-sm">
                        {{ vendor.address }},
                        {{ vendor.addresS2 || '-' }},
                        {{ vendor.city }},
                        {{ vendor.zip }}
                    </ion-text>
                </p> -->

                <!-- Actions -->
                <ion-row class="p-0">

                    <ion-col size="12" class="p-0 mb-2">
                        <ion-text class="primary-color font-family-bold vendorName text-wrap"
                            (click)="navigateVendor.emit(vendor)" (keydown.enter)="navigateVendor.emit(vendor)">
                            {{ vendor.vendoR_NAME || '-' }}
                        </ion-text>
                    </ion-col>

                    <ion-col size="12" class="p-0 d-flex gap-1">
                        <span class="cst-icon icon-location"></span>
                        <ion-text (click)="navigateVendor.emit(vendor)" (keydown.enter)="navigateVendor.emit(vendor)"
                            class="font-sm">
                            {{ vendor.address }},
                            {{ vendor.addresS2 || '-' }},
                            {{ vendor.city }},
                            {{ vendor.zip }}
                        </ion-text>
                    </ion-col>

                    @if (vendor.telephone) {
                    <ion-col size="12" class="p-0">
                        <a (click)="callHolman.emit(vendor.telephone)"
                            class="d-flex align-items-center gap-1 text-decoration-none">
                            <ion-icon name="call" class="cst-icon"></ion-icon>
                            <span>{{ vendor.telephone }}</span>
                        </a>
                    </ion-col>
                    }

                    @if (canScheduleAppt()) {
                    <ion-col size="12" class="p-0 d-flex align-items-center gap-1">
                        <ion-icon name="calendar-outline" class="cst-icon"></ion-icon>

                        <ion-button class="btn_secondary" (click)="saveVendor.emit(vendor)"
                            (keydown.enter)="saveVendor.emit(vendor)">
                            <span>{{'VENDOR_LABEL18' | translate}}</span>
                        </ion-button>

                    </ion-col>
                    }

                </ion-row>

            </ion-label>

        </ion-item>
    </ion-card>
    }

    <!-- Ionic Infinite Scroll -->
    <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMore.emit($event)" scrollTarget="vendorScroll"
        [disabled]="!hasMoreData()">

        <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more vendors...">
        </ion-infinite-scroll-content>

    </ion-infinite-scroll>
    } @else if(isServiceSelected()) {

    <div class="search-results w-100 d-flex justify-content-center">
        <ion-label>{{ 'MSG18' | translate }}</ion-label>
    </div>

    }
</ion-content>